import { NgModule } from '@angular/core';

@NgModule({

})

export class AppConfig {
  //COEGA QA
  baseUrl = "https://betacoegawebapi.coega.co.za";
  apiUrl = "https://betacoegawebapi.coega.co.za/api";

  //QA
  //baseUrl = "https://coega-api.purplecosmos.co.za/";
  //apiUrl = "https://coega-api.purplecosmos.co.za/api";

  //local
  //baseUrl = "https://localhost:44333";
  //apiUrl = "https://localhost:44333/api";

}
